import { GameInfoMapped } from '../interfaces/game-info/gameInfoMapped';

/** Картинки, которые Fabric подставляет в плейсхолдеры досок: лого команд и организатора, фото игроков. */
export function getGameInfoImageUrls(gameInfo?: GameInfoMapped): string[] {
  if (!gameInfo) return [];

  const { teams, organizer } = gameInfo;
  const urls: (string | undefined)[] = [organizer?.logo];

  for (const team of [teams?.firstTeam, teams?.secondTeam]) {
    urls.push(team?.logo);
    team?.members?.forEach((member) => urls.push(member.photo));
  }

  return urls.filter((url): url is string => !!url);
}
